import React from 'react'
import { IframeLayout } from '../../components/Layouts';
import { ErrorBoundary } from '@sentry/react';
import { ErrorMsg } from '../../components/AppMessages';
import LoadingEllipsis from '../../components/Loading/LoadingEllipsis';
import { IframePageContent } from '../../components/PageContent';
import { useStreamlitEmbedUrl } from '../../hooks';

const Clv = () => {
  const baseUrl = "https://clv-dashboard.streamlit.nissan-cedar.com/?embed=true";

  const { iframeUrl, isFetching } = useStreamlitEmbedUrl("clvToken", baseUrl);

  return (
    <IframeLayout hasFilter={false}>
      <ErrorBoundary fallback={<ErrorMsg />}>
        {isFetching ?
          <LoadingEllipsis isLoading={isFetching} />
          :
          <IframePageContent
            frameId="clvDashboard"
            iframeUrl={iframeUrl} // Use the iframe URL with the token query parameters
          />
        }

      </ErrorBoundary>
    </IframeLayout>
  );
}

export default Clv
